module.exports = __webpack_public_path__ + "media/08 the Qixi Festival.a117f174.mp3";